import { render, staticRenderFns } from "./addList.vue?vue&type=template&id=dacd63fe&scoped=true&"
import script from "./addList.vue?vue&type=script&lang=js&"
export * from "./addList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacd63fe",
  null
  
)

export default component.exports